import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from "react";
import "./index.css";
import { RegistrationComponentProps } from "../../lib";
import { usePasswordResetVerifyOtpMutation } from "../../../../backend/app";

export const VerifyOTP: FunctionComponent<RegistrationComponentProps> = ({
  setNextIsDisabled,
  registrationToken,
  setRegistrationToken,
  onNextClickRef,
}) => {
  const [otpCode, setOtpCode] = useState<string>("");

  useEffect(() => {
    setNextIsDisabled(otpCode.length !== 4);
  }, [otpCode, setNextIsDisabled]);

  const [verifyOtp] = usePasswordResetVerifyOtpMutation();

  onNextClickRef.current = useCallback(async () => {
    const resp = await verifyOtp({
      variables: {
        otpCode: parseInt(otpCode).toString(),
        token: registrationToken,
      },
      fetchPolicy: "no-cache",
    });

    setRegistrationToken(resp.data?.PasswordResetVerifyOtp);
  }, [setRegistrationToken, verifyOtp, registrationToken, otpCode]);
  return (
    <div className="hp">
      {/* <div className="company-tag">Gajiku Inc</div> */}
      <div className="header">
        <small>Harap masukan Nomor Kode OTP.</small>
      </div>
      <div className="container otp-number">
        <small>Nomor Kode</small>
        <div className="otp-field">
          <input
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            placeholder="Masukan OTP"
          />
        </div>
      </div>
    </div>
  );
};
